<template> 

    <span v-if="show_publication">
            
        <div class="col-md-6">

            <div class="ibox">

                <div class="ibox-content" style="min-height: 600px;">
 
                    <div class='row'>

                        <div class='col-md-8'>

                            <span class="label label-success m-b m-t">{{ publication.area }}</span>  

                            <br>
                            <br>

                            <h2>

                                <i class="fa fa-map-marker"></i> 

                                <span v-if="publication.city_name">
                                    <strong> {{ publication.city_name }} </strong> - 
                                </span>

                                <span v-if="publication.state_name">
                                    {{ publication.state_name }}
                                </span>

                                <span v-if="!publication.city_name && !publication.state_name">
                                    <strong> Não consta </strong>
                                </span>
                            
                            </h2>

                        </div> 

                        <div class="col-md-4 small text-right" v-if="!publicacoesVisualizadas">

                            <h5>Peritos que Visualizaram</h5>

                            <div>
                                <i class="fa fa-eye"></i> {{ authorViews  }}/3 visualizações Autor
                            </div> 
                            
                            <div>
                                <i class="fa fa-eye"></i> {{ defendantViews }}/3 visualizações Réu
                            </div> 

                        </div> 
                        
                    </div> 

                    <br>

                    <div class='row'>
                                
                        <div class='col-md-6'>

                            <div class="m-t m-b-xs"> 

                                <i class="fa fa-clock-o"></i>
                                <strong>Disponibilização:</strong> 

                                <span class="text-muted">
                                    {{ publication.availability_date }}
                                </span>

                            </div>

                            <div class="m-t m-b-xs"> 

                                <i class="fa fa-clock-o"></i>
                                <strong> Publicação: </strong> 

                                <span class="text-muted">
                                    {{ publication.publication_date }}
                                </span>

                            </div>

                            <br>
                            
                        </div>

                        <div class='col-md-6'>

                            <h5>
                                <i class="fa fa-info-circle"></i>
                                <strong>Tribunal </strong> - {{ publication.judicial_circuit }}
                            </h5> 

                            <h5>
                                <i class="fa fa-info-circle"></i>
                                <strong>Vara </strong> - {{ publication.court }}
                            </h5> 

                            <h5> 

                                <i class="fa fa-info-circle"></i>
                                <strong> Processo </strong> - 
    
                                <span  class='show-span' v-on:click="seen = true" v-if="seenAuthor || seenDefendant">
                                    {{ publication.process }}
                                </span>
                                
                                <span class='hide-span' v-else-if="!seenAuthor || !seenDefendant">
                                    **** ****
                                </span> 

                            </h5> 

                            <br>
                            
                        </div>

                        <hr style='border: 0.1px solid #0000004d;'>

                        <div class='col col-md-5' style='display: grid;' v-if="hasAuthorLawyer">

                            <h5>

                                <i class="fa fa-info-circle"></i>
                                <strong> Autor </strong> - 

                                <span  class='show-span' v-if="seenAuthor">
                                    {{ publication.author }}
                                </span>
                                
                                <span class='hide-span' v-else-if="!seenAuthor">
                                    **** ****
                                </span> 

                            </h5>

                            <h5>

                                <i class="fa fa-info-circle"></i>
                                <strong> Advogado Autor </strong> - 

                                <span  class='show-span' v-if="seenAuthor">
                                    {{ publication.author_lawyer_name }}
                                </span>
                                
                                <span class='hide-span' v-else-if="!seenAuthor">
                                    **** ****
                                </span> 

                            </h5>

                            <h5 v-for="(numero, index) in phoneLawyerAuthor">

                                <i class="fa fa-info-circle"></i>
                                <strong> Telefone Advogado</strong> - 

                                <a v-on:click="send_message(numero)" class='show-span' v-if="seenAuthor && numero.length >= 15">
                                    {{ numero }}
                                    <i class="fa fa-whatsapp" style="font-size: 17px;"></i>
                                </a>
                                
                                <a class='show-span' style="cursor: default; color: green;" v-if="seenAuthor && numero.length < 15">
                                    {{ numero }} 
                                </a>
                                
                                <span class='hide-span' v-else-if="!seenAuthor">
                                    **** ****
                                </span> 

                            </h5>
                            
                            <h5 v-for="(email, index) in emailLawyerAuthor">

                                <i class="fa fa-info-circle"></i>
                                <strong> Email Advogado</strong> - 

                                <span  class='show-span' v-if="seenAuthor">
                                    {{ email }}
                                </span>
                                
                                <span class='hide-span' v-else-if="!seenAuthor">
                                    **** ****
                                </span> 

                            </h5>

                            <button :disabled="seenAuthor" class='btn btn-primary' v-on:click="show(0)" style="width:100%">Me interessei</button>
    
                            <br>

                        </div>
                        <div class='col col-md-5' style='display: grid;' v-else>
                        </div>


                        <div class='col col-md-5 col-md-offset-1' style='display: grid;' v-if="hasDefendantLawyer">
                            
                            <h5>

                                <i class="fa fa-info-circle"></i>
                                <strong> Réu </strong> - 

                                <span  class='show-span' v-if="seenDefendant">
                                    {{ publication.defendant }}
                                </span>
                                
                                <span class='hide-span' v-else-if="!seenDefendant">
                                    **** ****
                                </span> 

                            </h5>

                            <h5>

                                <i class="fa fa-info-circle"></i>
                                <strong> Advogado Réu </strong> - 

                                <span  class='show-span' v-if="seenDefendant">
                                    {{ publication.defendant_lawyer_name }}
                                </span>
                                
                                <span class='hide-span' v-else-if="!seenDefendant">
                                    **** ****
                                </span> 

                            </h5>

                            <h5 v-for="(numero, index) in phoneLawyerDefendant">

                                <i class="fa fa-info-circle"></i>
                                <strong> Telefone Advogado Réu</strong> - 

                                <a v-on:click="send_message(numero)" class='show-span' v-if="seenDefendant && numero.length >= 15">
                                    {{ numero }}
                                    <i class="fa fa-whatsapp" style="font-size: 17px;"></i>
                                </a>
                                
                                <a class='show-span' style="cursor: default; color: green;" v-if="seenDefendant && numero.length < 15">
                                    {{ numero }} 
                                </a>
                                
                                <span class='hide-span' v-else-if="!seenDefendant">
                                    **** ****
                                </span> 

                            </h5>

                            <h5 v-for="(email, index) in emailLawyerDefendant">

                                <i class="fa fa-info-circle"></i>
                                <strong> Email Advogado Réu</strong> - 

                                <span  class='show-span' v-if="seenDefendant">
                                    {{ email }}
                                </span>
                                
                                <span class='hide-span' v-else-if="!seenDefendant">
                                    **** ****
                                </span> 

                            </h5>

                            <button :disabled="seenDefendant" class='btn btn-primary' v-on:click="show(1)" style="width:100%">Me interessei</button>

                            <br>

                        </div>

                    </div>

                    <br>

                    <i class="fa fa-info-circle"></i>
                    <strong>Contéudo da publicação</strong> 
                    
                    <br>
                    <br>
                    
                    <div class="row">
                            
                        <div class="col-md-12" style='background: #f3f3f4; border-radius:15px;'>
    
                            <span style='display: flex; min-height: 60px; word-break: break-all;'>
                                    
                                <p>
                                    {{ contentPublication }}
                                </p>
                        
                                <button style='margin-left: auto;' class='btn btn-primary btnContent' v-on:click="show_content_publication()">{{ btnChar }}</button>

                            </span>

                        </div>

                    </div>
                    
                </div>
                
            </div>

        </div>
     
        <div class="modal fade" :id="publication.id">
            <div class="modal-dialog modal-component" role="document">
                <div class="modal-box">

                    <div class="modal-title">
                        <h2>Visualizar Dados</h2>
                    </div>

                    <div class="modal-body h4" style="text-align: center;">

                        <dl class="dl-horizontal" style="width: 100%; overflow: hidden; padding: 0; margin: 0">
 
                            <h2 style="float: left; width: 100%; padding: 0; margin: 0; font-size: 20px; font-weight: 500;">Você pode abrir até <strong>{{ max_clicks }} contatos</strong> por hora.</h2>

                            <h2 style="float: left; width: 100%; padding: 0; margin: 0; font-size: 20px; font-weight: 500;">&nbsp;</h2>

                            <h2 style="float: left; width: 100%; padding: 0; margin: 0; font-size: 20px; font-weight: 500;">Não há consumo de créditos adquiridos na plataforma.</h2>
 
                            <h2 style="float: left; width: 100%; padding: 0; font-size: 20px; font-weight: 500;">Foram abertos <strong>{{ max_clicks - click }} contatos</strong> na última hora.</h2>
  
                        </dl>

                        <span v-if="click < 1"> 
                        
                            <h2 style="float: left; width: 100%; padding: 0; font-size: 20px; font-weight: 500;">Você atingiu o máximo de visualizações. Volte a utilizar na próxima hora.</h2>
                            <br> 
                        
                        </span>

                    </div>

                    <div class="modal-footer" style="margin-top: 35px;">

                        <div style="margin: auto;">
                                
                            <button data-dismiss="modal" class="btn btn-md btn-gray">Cancelar</button>

                            <span v-if="click >= 1">  
                            
                                <button :id='"btn_visualizar_" + publication.id' v-on:click='debt_click()' class="btn btn-md btn-primary">Visualizar Publicação</button>
                                    
                            </span>
                        
                        </div>

                    </div>

                </div>
            </div> 
        </div> 

    </span>

</template>

<script> 

    export default {  
        
        props: ['publication', 'max_clicks', 'viewed_publications'],
        data: function(){

                return {
                    
                    publicacoesVisualizadas: false,
                    path: window.location.pathname,
                    contentPublication: this.publication.publication_content_disguise.substring(0, 220).concat('...'),
                    contentFull: this.publication.publication_content_disguise,
                    btnChar: '+',
                    seenDefendant: this.publication.viewed_defendant == 1 ? true : false, 
                    seenAuthor: this.publication.viewed_author == 1 ? true : false, 
                    defendantViews: this.publication.defendant_views ? this.publication.defendant_views : 0,
                    authorViews: this.publication.author_views ? this.publication.author_views : 0 ,
                    phoneLawyerDefendant: '',
                    emailLawyerDefendant: '',
                    phoneLawyerAuthor: '',
                    emailLawyerAuthor: '',
                    visualizacao: this.urlParam('visualizacao'),
                    show_publication: false,
                    hasDefendantLawyer: !(this.publication.defendant_lawyer_oab) ? false : true,
                    hasAuthorLawyer: !(this.publication.author_lawyer_oab) ? false : true,
                    data: '',
                    caller: 0,
                    click: -1

                };

            },  
        mounted() {
            
            //Mostra o botão correto dependendo de qual pagina solicitou
            //
            if(this.path == '/minhas_publicacoes')
                this.publicacoesVisualizadas = true; 
            
            //Mostra as publicações que já foram visualizadas
            //
            var self = this;

            $.each(this.viewed_publications, function(key, value) {

                if(value.id == self.publication.id){ 

                    self.seenDefendant = value.defendant_viewed == 1 ? true : false;
                    self.seenAuthor = value.author_viewed == 1 ? true : false;

                    return false;

                }

            }); 

            if(this.seenAuthor == true){

                this.contentFull = this.publication.publication_content;
                this.contentPublication = this.contentFull.substring(0, 220).concat('...');

                self.show_info(this.publication.author_lawyer_oab, 0);

            }

            if(this.seenDefendant == true){

                this.contentFull = this.publication.publication_content;
                this.contentPublication = this.contentFull.substring(0, 220).concat('...');

                self.show_info(this.publication.defendant_lawyer_oab, 1);

            }

            //Define se a publicação ira ser mostrada, ou não - Filtro por dados Visualizados
            //  
            if(this.publicacoesVisualizadas){
                    
                switch(this.visualizacao){

                    case '2': 
                        if(!this.seenAuthor && this.seenDefendant) 
                            this.show_publication = true; 
                    break;

                    case '3': 
                        if(!this.seenDefendant && this.seenAuthor) 
                            this.show_publication = true; 
                    break;
                    
                    case '4': 
                        if(this.seenAuthor && this.seenDefendant) 
                            this.show_publication = true; 
                    break;

                    default: this.show_publication = true; 

                } 
            
            }else
                this.show_publication = true;
 
        },
        methods: {
            
            async show_info(oab_adv, type){

                await axios.post('/publicacoes/get_lawyer_info_load', {
                    oab: oab_adv,  
                })
                .then(response => (this.data = response));

                if(this.data.status == 200){
 
                    if(type == 1){    
 
                        this.phoneLawyerDefendant = this.data.data.telefones;
                        this.emailLawyerDefendant = this.data.data.emails;

                    }else{
 
                        this.phoneLawyerAuthor = this.data.data.telefones;
                        this.emailLawyerAuthor = this.data.data.emails;

                    }

                }

            },
            send_message(numero){

                numero = numero.replace('(','').replace(')','').replace('-','').replace(' ','');
                numero = '+55'+numero; 

                var text = 'Olá, tudo bem?\n\n\nVerifiquei que saiu uma publicação no processo '+this.publication.process+', envolvendo '+this.publication.author+' e '+this.publication.defendant+', para indicação de assistente técnico. Gostaria de me colocar à disposição para atendê-lo e, sendo do seu interesse, encaminhar uma proposta de serviços.\n\n\nObrigado.';
                var encodedUrl = "https://wa.me/"+numero+"?text="+text;

                window.open(encodeURI(encodedUrl), "_blank"); 

            },
            urlParam(name) {

                var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);

                if(results)
                    return results[1];
                else
                    return 0;

            },
            show_content_publication() {
                
                if(this.contentPublication.length <= 223){
                    
                    this.contentPublication = this.contentFull;
                    this.btnChar = '-'

                }else{

                    this.contentPublication = this.contentFull.substring(0, 220).concat('...');
                    this.btnChar = '+'

                }

            },
            async show(_caller) {

                //Pega quantidade atual de clicks
                //
                await axios.post('/publicacoes/get_clicks', {}).then(response => (this.click = response.data)); 

                $('#'+this.publication.id).modal('show');
                $('#'+this.publication.id).css('display', 'flex');
                
                this.caller = _caller; 
                
            }, 
            async debt_click() {
                 
                $("#btn_visualizar_" + this.publication.id).prop("disabled", true);

                //Pega as informações do advogado e debita o Click
                //
                await axios.post('/publicacoes/get_lawyer_info', {
                    oabDefendant: this.publication.defendant_lawyer_oab, 
                    oabAuthor: this.publication.author_lawyer_oab, 
                    publication_id: this.publication.id, 
                    type: this.caller
                })
                .then(response => (this.data = response));
                 
                $('#'+this.publication.id).modal('hide');
 
                if(this.data.status == 200){

                    this.contentFull =  this.publication.publication_content;
                    this.contentPublication = this.contentFull.substring(0, 220).concat('...');
 
                    if(this.caller == 1){    

                        this.seenDefendant = true;
                        this.defendantViews ++;
                        this.phoneLawyerDefendant = this.data.data.telefones;
                        this.emailLawyerDefendant = this.data.data.emails;

                    }else{

                        this.seenAuthor = true; 
                        this.authorViews ++;
                        this.phoneLawyerAuthor = this.data.data.telefones;
                        this.emailLawyerAuthor = this.data.data.emails;
                    
                    }

                }else{

                    $('#error').html(this.data.data)

                    setTimeout(function (){ 
                        $('#error-modal').modal('show');
                    }, 500)

                    setTimeout(function (){ 
                        $('#error-modal').modal('hide');
                    }, 70000)

                }

                $("#btn_visualizar_" + this.publication.id).prop("disabled", false);

            }

        }
    
    } 

</script> 

<style>
    
    body { 
        padding-right: 0 !important 
    }

    .btnContent{
        
        height: 35px;
        min-width: 35px;
        margin-top: 10px;
        margin-left: 5px;

    } 

    .hide-span{ 
        font-weight: 700;
        color: green; 
    } 

    .show-span{ 
        font-weight: 700;
        color: green; 
    } 

    .modal {
        text-align: center;
        padding: 0!important;
    }

    .modal:before {
        content: '';
        display: inline-block;
        height: 100%;
        vertical-align: middle;
        margin-right: -4px;
    }

    .modal-dialog {
        display: inline-block;
        text-align: left;
        vertical-align: middle;
    }
    
</style>